import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { Checkbox } from '@/components/ui/checkbox'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Mail, Clock, Send } from 'lucide-react'

interface EmailOptionsModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onProceed: (options: EmailOptions) => void
  onSkip: () => void
  selectedEmployeeCount: number
}

export interface EmailOptions {
  sendEmail: boolean
  timing: 'immediately' | 'after_assignment'
}

const EmailOptionsModal = ({
  open,
  onOpenChange,
  onProceed,
  onSkip,
  selectedEmployeeCount,
}: EmailOptionsModalProps) => {
  const [sendEmail, setSendEmail] = React.useState(true)
  const [timing, setTiming] = React.useState<'immediately' | 'after_assignment'>('after_assignment')

  const handleProceed = () => {
    onProceed({ sendEmail, timing })
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Mail className="h-5 w-5" />
            Email Gönderimi
          </DialogTitle>
          <DialogDescription className="text-sm">
            {selectedEmployeeCount} çalışana sınav atandıktan sonra email göndermek istiyor musunuz?
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="flex items-start space-x-3 p-3 border rounded-lg">
            <Checkbox
              id="send-email"
              checked={sendEmail}
              onCheckedChange={(checked) => setSendEmail(checked as boolean)}
              className="mt-1"
            />
            <div className="space-y-1 flex-1">
              <Label htmlFor="send-email" className="text-sm font-medium cursor-pointer">
                Çalışanlara email gönder
              </Label>
              <p className="text-xs text-muted-foreground leading-tight">
                Sınav atama işlemi tamamlandıktan sonra seçili çalışanlara otomatik email
                gönderilecektir.
              </p>
            </div>
          </div>

          {/*{sendEmail && (
            <div className="space-y-3 pl-3 border-l-2 border-primary/20">
              <div className="space-y-2">
                <Label className="text-sm font-medium flex items-center gap-2">
                  <Clock className="h-4 w-4" />
                  Gönderim Zamanı
                </Label>
                <Select
                  value={timing}
                  onValueChange={(value: "immediately" | "after_assignment") =>
                    setTiming(value)
                  }
                >
                  <SelectTrigger className="w-full">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="after_assignment">
                      <div className="flex items-center gap-2 text-sm">
                        <Clock className="h-4 w-4" />
                        Sınav atandıktan sonra
                      </div>
                    </SelectItem>
                    <SelectItem value="immediately">
                      <div className="flex items-center gap-2 text-sm">
                        <Send className="h-4 w-4" />
                        Hemen gönder
                      </div>
                    </SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <div className="bg-blue-50 p-2 rounded-md border border-blue-200">
                <p className="text-xs text-blue-800">
                  📧{" "}
                  {timing === "after_assignment"
                    ? "Sınav başarıyla atandıktan sonra email gönderilecek"
                    : "Email anında gönderilecek"}
                </p>
              </div>
            </div>
          )} */}
        </div>

        <DialogFooter className="flex flex-col sm:flex-row gap-2 pt-4">
          <Button variant="outline" onClick={onSkip} className="w-full sm:w-auto">
            Email Göndermeden Devam Et
          </Button>
          <Button onClick={handleProceed} className="w-full sm:w-auto">
            {sendEmail ? 'Email İçeriğini Düzenle' : 'Sınavı Ata'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default EmailOptionsModal
